import React, { useRef } from 'react';
import { NoResults } from '~/features/productsList/components';
import { M30ProductCarouselModule as M30ProductCarouselProps } from '~/lib/data-contract';
import { AlgoliaClientSearch } from '~/features/productsList/components';
import { useAlgoliaConfig } from '~/shared/hooks/useAlgoliaConfig';
import { useInView } from '~/shared/hooks/useInView/useInView';
import { config } from './constants';
import { connectInfiniteHits } from 'react-instantsearch-dom';
import { AlgoliaHit } from '~/templates/blocks/components/carousel/models';
import ProductCarousel, {
    Props as HitCarouselProps,
} from './components/product-carousel/product-carousel.component';
import { Container } from '../container/container.component';

const CarouselHits = connectInfiniteHits<HitCarouselProps, AlgoliaHit>(ProductCarousel);

const M30ProductCarousel = ({
    maxNumberItems = 24,
    category,
    context,
    ...rest
}: M30ProductCarouselProps) => {
    const ref = useRef(null);
    const { key, token } = useAlgoliaConfig();
    const isInView = useInView(ref, config.intersectionObserverOptions);

    return (
        <div ref={ref}>
            {isInView ? (
                <Container {...rest}>
                    <AlgoliaClientSearch
                        hitsPerPage={maxNumberItems ?? config.maxNumberItemsDefault}
                        algoliaApp={key}
                        algoliaToken={token}
                        category={category}
                        context={context}
                        shouldControlUrl={false}
                    >
                        <NoResults type="carousel">
                            <CarouselHits />
                        </NoResults>
                    </AlgoliaClientSearch>
                </Container>
            ) : null}
        </div>
    );
};

export default M30ProductCarousel;
